import React, { useState } from "react";
import { Button } from "@mui/material";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./navbar.css";

export default function Navbar() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="navbar">
      <div className="logo">
        <a href="#Header" style={{ textDecoration: "none" }}>
          <img src="../images/pristinePvLogo.jpg" alt="logo" />
        </a>
      </div>
      <div className="navItem">
        <ul className="navLinks">
          <a href="#OurSolution" style={{ textDecoration: "none" }}>
            <li>Our Solution</li>
          </a>
          <a href="#OurServices" style={{ textDecoration: "none" }}>
            <li>Our Services</li>
          </a>
          <a href="#ServicePlan" style={{ textDecoration: "none" }}>
            <li>Services Plan</li>
          </a>
          <a href="#ContactUs" style={{ textDecoration: "none" }}>
            <li>Contact Us</li>
          </a>
        </ul>
        <Button variant="contained" color="primary">
          Get Started
        </Button>
      </div>
      <div className="menuIcon">
        <i className="bi bi-list" onClick={handleShow}></i>
      </div>

      <Offcanvas show={show} onHide={handleClose} className="navOffcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src="../images/pristinePvLogo.jpg" alt="log"></img>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="homeSideBar">
            <ul className="navLinks">
              <a href="#OurSolution" style={{ textDecoration: "none" }}>
                <li>Our Solution</li>
              </a>
              <a href="#OurServices" style={{ textDecoration: "none" }}>
                <li>Our Services</li>
              </a>
              <a href="#ServicePlan" style={{ textDecoration: "none" }}>
                <li>Services Plan</li>
              </a>
              <a href="#ContactUs" style={{ textDecoration: "none" }}>
                <li>Contact Us</li>
              </a>
            </ul>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
